import Vue from 'vue'
import { Sticky, Popup, List, Rate, Checkbox, CheckboxGroup,RadioGroup, Radio ,Field,Button,Toast } from "vant";
Vue.use(Sticky);
Vue.use(Popup);
Vue.use(List);
Vue.use(Rate);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Field);
Vue.use(Button);
Vue.use(Toast );
import '../../assets/style/index.less'
import page from './page.vue'
Vue.config.productionTip = false
new Vue({
  render: h => h(page),
}).$mount('#app')